"use client";

import { DialogClose } from "@trydig/ui";
import { useMediaQuery } from "@trydig/ui/hooks";
import { atom, useAtom } from "jotai";
import { type PropsWithChildren, useEffect } from "react";
import { XIcon } from "@/components/icons/XIcon";
import { AnimatedBurgerIcon } from "@/components/ui/Burger";
import {
	ModalContent,
	ModalMain,
	ModalRoot,
	ModalTrigger,
	ModalViewport,
} from "@/components/ui/Drawer";
import { IconButton } from "@/components/ui/IconButton";
import styles from "./Header.module.css";

export const mobileOpen = atom(false);
export const useMobileMenu = () => {
	const [open, setOpen] = useAtom(mobileOpen);
	const matches = useMediaQuery("(max-width: 767px)");

	useEffect(() => {
		if (!matches) {
			setOpen(false);
		}
	}, [matches, setOpen]);

	return {
		open,
		setOpen,
	};
};

export const MobileMenu = ({ children }: PropsWithChildren<{}>) => {
	const { open, setOpen } = useMobileMenu();
	return (
		<ModalRoot open={open} onOpenChange={setOpen}>
			<ModalTrigger asChild>
				<AnimatedBurgerIcon
					data-state={open ? "open" : undefined}
					open={open}
					className={styles.mobileMenuTrigger}
				/>
			</ModalTrigger>
			<ModalViewport color="yellow">
				<ModalContent>
					<ModalMain>
						<DialogClose asChild className={styles.close}>
							<IconButton className={styles.closeButton}>
								<XIcon />
							</IconButton>
						</DialogClose>
						{children}
					</ModalMain>
				</ModalContent>
			</ModalViewport>
		</ModalRoot>
	);
};
